module.exports = __webpack_public_path__ + "img/icon1.eb013cdb.png";